import { render, staticRenderFns } from "./PersonFormPage.vue?vue&type=template&id=221a40fd&"
import script from "./PersonFormPage.vue?vue&type=script&lang=js&"
export * from "./PersonFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports